import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';


export abstract class HashComponent extends GeneralExerciseComponent {

  elementType: string = 'number';
  elements: any[] = [];
  selection: number[];
  typeFunction: string;
  scalar: number;
  divisor: number;
  compute: string[];
  hashElements: boolean;
  linearProbing: boolean;
  caretPos: number = 0;

  hashed: any = "hello";
  selected: any;
  precomputationS: string;
  precomputationPosition: number;

  data: any[] = [];

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.elementType = this.configuration.typespecifics.elementType;
    this.elements = this.configuration.typespecifics.elements;
    this.selection = this.configuration.typespecifics.selection;
    this.typeFunction = this.configuration.typespecifics.typeFunction;
    this.scalar = this.configuration.typespecifics.scalar;
    this.divisor = this.configuration.typespecifics.divisor;
    this.compute = this.configuration.typespecifics.compute;
    this.hashElements = this.configuration.typespecifics.hashElements;
    this.linearProbing = this.configuration.typespecifics.linearProbing;
    if(this.typeFunction == 'digits'){
      this.computeBuckets();
    }
    if(this.typeFunction == 'checksum'){
      this.divisor = 10;
    }
    this.hashed = [];
    for (let i = 0; i < this.divisor; i++) {
      this.hashed.push([]);
      this.data.push({ name: i.toString(), value: 0 });
    }
    this.hashed.push([]);
    let last = this.hashed[this.hashed.length - 1]
    for (let element of this.elements) {
      let precomputed = undefined;
      let elem = {
        value: element,
        precomputed: precomputed,
        operation: undefined,
        scaled: undefined,
        hash: undefined
      };
      this.selected = elem;
      if (this.elementType == 'number') {
        this.precomputationS = element.toString().split("").join(",");
        this.changePrecomputation();
      } else {
        if (this.compute.includes('precomputation')) {
          this.precomputationS = element.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
          this.changePrecomputation();
        }
      }
      if (elem.hash == undefined || !this.hashElements) {
        last.push(elem)
      }
    }
  }

  setTypeSpecificsFromState() {
    if (this.state != undefined) {
      if (this.state.typespecific.hashed != undefined) {
        this.hashed = this.state.typespecific.hashed;
      }
    }
  }

  computeBuckets(){
    let maxHash = -1;
    for (let element of this.elements) {
      let precomputed = undefined;
      let elem = {
        value: element,
        precomputed: precomputed,
        operation: undefined,
        scaled: undefined,
        hash: undefined
      };
      this.selected = elem;
      if (this.elementType == 'number') {
        this.precomputationS = element.toString().split("").join(",");
        this.changePrecomputation(true);
      } else {
        if (this.compute.includes('precomputation')) {
          this.precomputationS = element.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
          this.changePrecomputation(true);
        }
      }
      if (elem.hash > maxHash) {
        maxHash=elem.hash;
      }
    }
    this.divisor = maxHash + 1;
  }

  computeState() {
    this.state.typespecific.hashed = this.hashed;
  }


  evaluate(): number[] {
    return [1,1];
  }

  /** returns the string for the addition or multiplication */
  getOperationString(): string {
    let result = "";
    if (this.selected.precomputed != undefined) {
      let separator = "";
      if (this.selection.length > 0) {
        for (let i of this.selection) {
          if (this.selected.precomputed[i] == undefined) {
            if (this.typeFunction == "addition") {
              result = result.concat(separator, "0");
            } else {

              result = result.concat(separator, "1");
            }

          } else {
            result = result.concat(separator, this.selected.precomputed[i]);
          }
          separator = " * ";
          if (this.typeFunction == "addition") {
            separator = " + ";
          }
        }
      } else {
        for (let i of this.selected.precomputed) {
          result = result.concat(separator, i);
          separator = " * ";
          if (this.typeFunction == "addition") {
            separator = " + ";
          }
        }

      }
    }
    return result;
  }

  /** set caret position and compute numbers */
  onKeyUp(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPos = oField.selectionStart;
    }
    if (this.precomputationS == undefined || this.precomputationS == "") {
      this.precomputationPosition = this.selected.value.toLowerCase().charCodeAt(0) - 97;
      return;
    }
    let myPart = this.precomputationS.substring(0, this.caretPos);
    let myNumbers = myPart.split(",");
    this.precomputationPosition = this.selected.value.toLowerCase().charCodeAt(myNumbers.length - 1) - 97;
  }

  /** normalize precomputation and start operation computation */
  changePrecomputation(test = false) {
    this.selected.precomputed = this.precomputationS.split(",").map(v => +v);
    this.computeOperation(test);
  }

  /** compute the operation */
  computeOperation(test = false) {
    if (!this.compute.includes('operation') && !test) {
      return;
    }
    if(this.typeFunction == 'digits'){
      let result:any = "";
      for(let i of this.selection){
        result = result.concat(this.selected.precomputed[i].toString());
      }

      result = +result;
      this.selected.hash = result;
      this.hashElement(this.hashed.length - 1, test);
      return;
    } 
    if(this.typeFunction == "checksum"){
      let result: any =this.selected.value.toString();
      while(result.length > 1){
        let temp = 0;
        for(let digit of result){
          temp = temp + +digit;
        }
        result = temp.toString();
      }
      result = +result;
      this.selected.hash = result;
      this.hashElement(this.hashed.length - 1, test);
      return;
    }
    let result = 0;
    if (this.typeFunction == 'addition') {
      result = 0;
      if (this.selection.length > 0) {
        for (let i of this.selection) {
          if (this.selected.precomputed[i] != undefined) {
            result = result + this.selected.precomputed[i];
          }
        }
      } else {
        for (let i of this.selected.precomputed) {
          result = result + i;
        }
      }
    }
    else {
      result = 1;
      if (this.selection.length > 0) {
        for (let i of this.selection) {
          if (this.selected.precomputed[i] != undefined) {
            result = result * this.selected.precomputed[i];
          }
        }
      } else {
        for (let i of this.selected.precomputed) {
          result = result * i;
        }
      }
    }
    this.selected.operation = result;
    this.computeScale(test);
  }

  /** compute the scale */
  computeScale(test = false) {
    if (!this.compute.includes('scale') && !test) {
      return;
    }
    this.selected.scaled = this.selected.operation * this.scalar;
    this.computeDivision(test);
  }

  /** compute the division */
  computeDivision(test = false) {
    if (!this.compute.includes('modulo') && !test) {
      return;
    }
    let oldHash = this.selected.hash;
    this.selected.hash = this.selected.scaled % this.divisor;
    this.hashElement(oldHash, test);
  }

  /** add element to is hash-bucket */
  hashElement(oldHash = this.hashed.length - 1, test = false) {
    if (this.selected.hash > this.hashed.length - 2) {
      return;
    }
    oldHash = this.hashed.length - 1;
    let i = 0;
    for (let bucket of this.hashed) {
      for (let elem of bucket) {
        if (elem.value == this.selected.value) {
          oldHash = i;
        }
      }
      i++;
    }
    if (this.hashElements && !test) {
      if (!this.linearProbing) {
        this.hashed[oldHash].splice(this.hashed[oldHash].indexOf(this.selected), 1);
        this.hashed[this.selected.hash].push(this.selected);
        this.data[this.selected.hash].value++;
        if (oldHash < this.hashed.length - 1) {
          this.data[oldHash].value--;
        }
        this.data = [...this.data];
      } else if (oldHash == this.hashed.length - 1) {
        this.hashed[oldHash].splice(this.hashed[oldHash].indexOf(this.selected), 1);
        let myBucketIndex: number = this.selected.hash;
        while (this.hashed[myBucketIndex % this.divisor].length > 0) {
          myBucketIndex++;
        }
        this.hashed[myBucketIndex % this.divisor].push(this.selected);
        this.data[myBucketIndex % this.divisor].value++;
      }
      else {
        let oldSelected = this.selected;
        let oldprecomputationS = this.precomputationS;
        let tempHashed = this.hashed;
        this.hashed = new Array();
        for (let i = 0; i < tempHashed.length; i++) {
          this.hashed.push([]);
        }

        for (let pair of this.data) {
          pair.value = 0;
        }
        for (let bucket of tempHashed.slice(0, tempHashed.length - 1)) {
          if (bucket.length > 0) {
            this.selected = bucket[0];
            this.hashElement(this.hashed.length - 1);
          }

        }

        this.hashed[tempHashed.length - 1] = tempHashed[tempHashed.length - 1];

        this.data = [...this.data];
        this.selected = oldSelected;
        this.precomputationS = oldprecomputationS;
      }
    }
  }

  /** returns the string representation of the hash function */
  getHashFunction(): string {
    let separator = "";
    let result = "";
    if(this.typeFunction == 'digits'){
      for(let i of this.selection){
        result = result.concat("a",i.toString());
      }
      return result;
    }
    if(this.typeFunction == "checksum"){
      return this.get("checksum");
    }
    for (let i of this.selection) {
      result = result.concat(separator, "a".concat(i.toString()));
      separator = " * ";
      if (this.typeFunction == "addition") {
        separator = " + ";
      }
    }
    if (this.selection.length == 0) {
      if (this.typeFunction == "addition") {
        result = "a0 + a1 + ...";
      } else {
        result = "a0 * a1 * ...";
      }
    }
    result = "Rest von ((".concat(result, ")", " * ", this.scalar ? this.scalar.toString() : "???", ")", " / ", this.divisor ? this.divisor.toString() : "???")
   return result;
  }

  fromCharCode(i: number): string {
    return String.fromCharCode(i);
  }




}
